import { mapGetters } from 'vuex';

export const loadingComputed = {
  ...mapGetters('auth', ['currentUserDataLoading']),
  ...mapGetters('recordings', ['isRecordingsLoading']),
  ...mapGetters('qalon', ['isQalonNarrationLoading']),
  ...mapGetters('otherNarrations', ['isOtherNarrationsLoading']),
  ...mapGetters('kids', ['isKidsNarrationLoading']),
  ...mapGetters('folders', ['isFoldersLoading']),
  loading() {
    return (
      this.currentUserDataLoading,
      this.isRecordingsLoading,
      this.isQalonNarrationLoading,
      this.isOtherNarrationsLoading,
      this.isKidsNarrationLoading,
      this.isFoldersLoading
    );
  }
};
